import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/machine-learning/page.tsx");
